import { layoutTargets } from './layoutTargets';
import { preview } from './preview';

export const PlayerOnly = {
  layoutTargets,
  preview,
};
